import { useMutation, useQueryClient } from '@tanstack/react-query';
import { reservationKeys, reservationOptions } from '../../constants/reservations';
export function useReservationActions() {
    const queryClient = useQueryClient();
    const invalidateReservations = () => queryClient.invalidateQueries({ queryKey: reservationKeys.all });
    const createMutation = useMutation({ ...reservationOptions.create(), onSuccess: invalidateReservations });
    const swapVehicleMutation = useMutation({
        ...reservationOptions.swapVehicle(),
        onSuccess: invalidateReservations,
    });
    const addVehicleMutation = useMutation({
        ...reservationOptions.addVehicle(),
        onSuccess: invalidateReservations,
    });
    const removeVehicleMutation = useMutation({
        ...reservationOptions.removeVehicle(),
        onSuccess: invalidateReservations,
    });
    const reassignSpanSpotMutation = useMutation({
        ...reservationOptions.reassignSpanSpot(),
        onSuccess: invalidateReservations,
    });
    const initiatePaymentMutation = useMutation({
        ...reservationOptions.initiatePayment(),
        onSuccess: invalidateReservations,
    });
    const requestSpanExtensionMutation = useMutation(reservationOptions.requestSpanExtension());
    const initiateSpanExtensionPaymentMutation = useMutation({
        ...reservationOptions.initiateSpanExtensionPayment(),
        onSuccess: invalidateReservations,
    });
    const initiateSpanPaymentMutation = useMutation({
        ...reservationOptions.initiateSpanPayment(),
        onSuccess: invalidateReservations,
    });
    const setRevolvingMutation = useMutation({
        ...reservationOptions.setRevolving(),
        onSuccess: invalidateReservations,
    });
    const cancelMutation = useMutation({ ...reservationOptions.cancel(), onSuccess: invalidateReservations });
    const exportCsvMutation = useMutation(reservationOptions.exportToCsv());
    const exportPdfMutation = useMutation(reservationOptions.exportToPdf());
    return {
        createReservation: createMutation.mutateAsync,
        creatingReservation: createMutation.isPending,
        swapVehicleInReservation: swapVehicleMutation.mutateAsync,
        swappingVehicleInReservation: swapVehicleMutation.isPending,
        addVehicleToReservation: addVehicleMutation.mutateAsync,
        addingVehicleToReservation: addVehicleMutation.isPending,
        removeVehicleFromReservation: removeVehicleMutation.mutateAsync,
        removingVehicleFromReservation: removeVehicleMutation.isPending,
        reassignReservationSpanSpot: reassignSpanSpotMutation.mutateAsync,
        reassigningReservationSpanSpot: reassignSpanSpotMutation.isPending,
        initiateReservationPayment: initiatePaymentMutation.mutateAsync,
        initiatingReservationPayment: initiatePaymentMutation.isPending,
        requestReservationSpanExtension: requestSpanExtensionMutation.mutateAsync,
        requestingReservationSpanExtension: requestSpanExtensionMutation.isPending,
        initiateReservationSpanExtensionPayment: initiateSpanExtensionPaymentMutation.mutateAsync,
        initiatingReservationSpanExtensionPayment: initiateSpanExtensionPaymentMutation.isPending,
        initiateReservationSpanPayment: initiateSpanPaymentMutation.mutateAsync,
        initiatingReservationSpanPayment: initiateSpanPaymentMutation.isPending,
        setReservationRevolving: setRevolvingMutation.mutateAsync,
        settingReservationRevolving: setRevolvingMutation.isPending,
        cancelReservation: cancelMutation.mutateAsync,
        cancellingReservation: cancelMutation.isPending,
        exportToCsv: exportCsvMutation.mutateAsync,
        exportingCsv: exportCsvMutation.isPending,
        exportToPdf: exportPdfMutation.mutateAsync,
        exportingPdf: exportPdfMutation.isPending,
    };
}
